import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function About() {
  return <section id="about" className="py-20 md:py-32 bg-white" data-id="element-11">
      <div className="container mx-auto px-6" data-id="element-12">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-13">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2" data-id="element-14">
            <div className="relative aspect-[4/5] w-full max-w-md mx-auto md:mr-auto" data-id="element-15">
              <div className="absolute inset-0 bg-warm-gray translate-x-4 translate-y-4" data-id="element-16" />
              <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Luxury home exterior" className="relative z-10 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-17" />
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full md:w-1/2" data-id="element-18">
            <span className="block text-gold font-heading text-sm uppercase tracking-widest font-semibold mb-4" data-id="element-19">
              Meet Nathan Rance
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-charcoal uppercase tracking-wide mb-6" data-id="element-20">
              Real Estate Done Right
            </h2>
            <div className="font-body text-charcoal/70 space-y-6 text-lg leading-relaxed mb-8" data-id="element-21">
              <p data-id="element-22">
                With a commitment to integrity, market expertise, and a
                client-first approach, Nathan Rance delivers a real estate
                experience that's anything but ordinary.
              </p>
              <p data-id="element-23">
                Whether you're buying your first home, selling a property, or
                investing in your future — you'll have a dedicated partner every
                step of the way.
              </p>
            </div>
            <a href="#contact" className="inline-flex items-center gap-2 text-charcoal font-heading uppercase tracking-wider text-sm font-semibold hover:text-gold transition-colors group" data-id="element-24">
              Learn More About Nathan
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-25" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}